import React, { useState, useRef } from 'react';
import SimpleReactValidator from 'simple-react-validator';
import Swal from 'sweetalert2';
import axios from 'axios';
import ReCAPTCHA from 'react-google-recaptcha';

const ContactForm = () => {
  const [forms, setForms] = useState({
    name: '',
    email: '',
    phoneno: '',
    msg: '',
    subject: '',
    reCaptcha: '',
  });

  const recaptchaRef = useRef();
  const [validator] = useState(
    new SimpleReactValidator({ className: 'errorMessage', autoForceUpdate: this })
  );

  const changeHandler = (e) => {
    setForms({ ...forms, [e.target.name]: e.target.value });
  };

  const handleRecaptchaChange = (value) => {
    setForms({ ...forms, reCaptcha: value });
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    if (!validator.allValid()) {
      validator.showMessages();
      return;
    }

    if (!forms.reCaptcha) {
      Swal.fire({
        icon: 'warning',
        title: 'Captcha Required',
        text: 'Please verify you are not a robot.',
      });
      return;
    }

    const formData = {
      name: forms.name,
      email: forms.email,
      phoneno: forms.phoneno,
      comment: forms.msg,
      subject: forms.subject,
      reCaptcha: forms.reCaptcha,
    };

    try {
      const response = await axios.post(
        'https://tigrispay.com/prod/api/contactus/savecontactdetails',
        formData
      );

      const { response: status, responseCode, data } = response.data;

      if (status === true && responseCode === '00') {
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: 'Customer Details added Successfully!',
          timer: 2000,
          showConfirmButton: false,
        });

        setForms({
          name: '',
          email: '',
          phoneno: '',
          comment: '',
          subject: '',
          reCaptcha: '',
        });

        recaptchaRef.current.reset();
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: data || 'Something went wrong.',
          showConfirmButton: true,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Network Error',
        text: 'Something went wrong. Please try again.',
        showConfirmButton: true,
      });
    }
  };

  return (
    <form onSubmit={submitHandler} className="contact-form">
      <div className="row">
        <div className="col-lg-6">
          <div className="input-field">
            <label htmlFor="name">Name*</label>
            <div className="input-box">
              <input
                value={forms.name}
                type="text"
                name="name"
                className="form-control"
                onBlur={() => validator.showMessageFor('name')}
                onChange={changeHandler}
                onInput={(e) => (e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, ''))}
                placeholder="Enter your name"
              />
              {validator.message('name', forms.name, 'required|alpha_space')}
            </div>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="input-field">
            <label htmlFor="email">Email*</label>
            <div className="input-box">
              <input
                value={forms.email}
                type="email"
                name="email"
                className="form-control"
                onBlur={() => validator.showMessageFor('email')}
                onChange={changeHandler}
                placeholder="Enter your email"
              />
              {validator.message('email', forms.email, 'required|email')}
            </div>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="input-field">
            <label htmlFor="phoneno">Phone*</label>
            <div className="input-box">
              <input
                value={forms.phoneno}
                type="text"
                name="phoneno"
                className="form-control"
                onBlur={() => validator.showMessageFor('phoneno')}
                onChange={changeHandler}
                onInput={(e) => (e.target.value = e.target.value.replace(/[^0-9]/g, ''))}
                maxLength={15}
                placeholder="Enter your phone number"
              />
              {validator.message('phoneno', forms.phoneno, 'required|numeric')}
            </div>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="input-field">
            <label htmlFor="subject">Subject*</label>
            <div className="input-box">
              <input
                value={forms.subject}
                type="text"
                name="subject"
                className="form-control"
                onBlur={() => validator.showMessageFor('subject')}
                onChange={changeHandler}
                placeholder="Enter your subject"
              />
              {validator.message('subject', forms.subject, 'required')}
            </div>
          </div>
        </div>

        <div className="col-lg-12">
          <div className="input-field text-field">
            <label htmlFor="msg">Message*</label>
            <div className="input-box">
              <textarea
                value={forms.msg}
                name="msg"
                className="form-control"
                placeholder="How can we help you?"
                onBlur={() => validator.showMessageFor('msg')}
                onChange={changeHandler}
              ></textarea>
              {validator.message('msg', forms.msg, 'required')}
            </div>
          </div>
        </div>

        <div className="col-lg-12 mt-3">
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey="6LflOOsrAAAAAEns55E1-c_awAI9hx6KiBBvuq7k"
            onChange={handleRecaptchaChange}
          />
        </div>
      </div>

      <div className="cp-det-btn mt-20 d-grid">
        <button className="cp-btn" type="submit">
          Send us a message <i className="fal fa-arrow-right"></i>
        </button>
      </div>
    </form>
  );
};

export default ContactForm;
